import React, { useState, useRef } from 'react';
import NumberSlideBar from '@src/framework/frame/components/property-editor/editor-components/number-slidebar';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { DEFAULT_CLICK_SPID } from '@tencent/slide-sdk-model';
import { IAnimModel } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import styles from './index.less';

interface IProps {
    selectionService?: ISelectionService;
    selectedAnimList?: Array<IAnimModel>;
    type: 'duration' | 'delay';
}

const MIN_VALUE_MAP = {
    duration: 0.01,
    delay: 0,
};

const AnimSelector = (props: IProps) => {
    const { selectionService, selectedAnimList, type } = props;
    const getInitValue = () => {
        const typeValue = selectedAnimList?.[0]?.props[type];
        if (!typeValue) return MIN_VALUE_MAP[type];
        if (selectedAnimList?.every(animModel => animModel?.props[type] === typeValue)) {
            return typeValue / 1000;
        }
        return MIN_VALUE_MAP[type];
    };

    const [duration, setDuration] = useState(getInitValue());
    const focusRef = useRef(false);

    const handleInputBlur = () => {
        focusRef.current = false;
        const durationNum = parseFloat(String(duration));
        const value = Math.max(MIN_VALUE_MAP[type], isNaN(durationNum) ? 0 : durationNum);
        setDuration(value);
    };
    const handleInputFocus = () => {
        focusRef.current = true;
        const durationNum = parseFloat(String(duration));
        const value = Math.max(MIN_VALUE_MAP[type], isNaN(durationNum) ? 0 : durationNum);
        setDuration(value);
    };
    const handleChange = (type, value, fromCustom, changing) => {
        const valueNum = parseFloat(value);
        let dur = focusRef.current ? value : Math.max(MIN_VALUE_MAP[type], valueNum);
        setDuration(dur);
        const needModify = !changing;
        if (!needModify) return;
        dur = Math.max(MIN_VALUE_MAP[type] * 1000, (isNaN(valueNum) ? 0 : valueNum) * 1000);
        selectedAnimList?.forEach((animModel) => {
            if (!animModel.clickSpid) {
                animModel.clickSpid = DEFAULT_CLICK_SPID;
            }
            selectionService?.currentSlide?.modifyAnimation(animModel, { [type]: dur });
        });
    };
    const handleClick = (e) => {
        e.stopPropagation();
    };

    const getMaxValue = (type): number => {
        const map = {
            duration: 600,
            delay: 60,
        };

        return map[type];
    };

    const getMinValue = (type): number => {
        const map = {
            duration: 0.01,
            delay: 0,
        };

        return map[type];
    };

    return (
        <div onClick={handleClick} className={styles['anim-duration-select']}>
            <NumberSlideBar
                title={''}
                value={duration}
                toFixed={2}
                slideBarStep={0.5}
                numberInputStep={0.5}
                lowerLimit={getMinValue(type)}
                upperLimit={getMaxValue(type)}
                sliderUpperLimit={60}
                allowDecimal={true}
                postFix={'s'}
                sliderStyle={{ width: 144 }}
                sliderContainerStyle={{ marginTop: 0 }}
                type={type}
                onBlur={handleInputBlur}
                onFocus={handleInputFocus}
                onValueChange={handleChange}
                onValueEnter={() => {}}
                onValueLeave={() => {}}
                canShowEmptyString={true}
                isIntegerOfStep={true}
            />
        </div>
    );
};

export default AnimSelector;
